import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { CalendarOutlined, CheckCircleOutlined, ClockCircleOutlined, AlertOutlined } from '@ant-design/icons';

const SummaryCards = ({ setting }) => (
  <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
    <Col xs={12} md={6}>
      <Card size="small">
        <Statistic
          title="Mês atual"
          value={setting.current_month_label || '-'}
          prefix={<CalendarOutlined />}
          valueStyle={{ fontSize: 18 }}
        />
      </Card>
    </Col>
    <Col xs={12} md={6}>
      <Card size="small">
        <Statistic
          title="Pagas / Total"
          value={`${setting.paid_count}/${setting.total_count}`}
          prefix={<CheckCircleOutlined style={{ color: '#52C41A' }} />}
          valueStyle={{ fontSize: 18, color: '#52C41A' }}
        />
      </Card>
    </Col>
    <Col xs={12} md={6}>
      <Card size="small">
        <Statistic
          title="Pendentes"
          value={setting.pending_count}
          prefix={<ClockCircleOutlined style={{ color: '#FAAD14' }} />}
          valueStyle={{ fontSize: 18, color: '#FAAD14' }}
        />
      </Card>
    </Col>
    <Col xs={12} md={6}>
      <Card size="small">
        <Statistic
          title="Em débito 30d+"
          value={setting.debtors_30d_count}
          prefix={<AlertOutlined style={{ color: '#F5222D' }} />}
          valueStyle={{ fontSize: 18, color: setting.debtors_30d_count > 0 ? '#F5222D' : undefined }}
        />
      </Card>
    </Col>
  </Row>
);

export default SummaryCards;
